import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Panelize from 'shared/components/parameters/Panelize';
import PrintConfirmation from 'shared/components/parameters/PrintConfirmation';
import SpecialInstructions from 'shared/components/parameters/SpecialInstructions';

import { changeStencilsParameter } from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';
import { validator } from 'shared/product_tabs/tab_stencils/slice/validator';
import { selectStencilsParameters, selectStencils } from 'shared/product_tabs/tab_stencils/slice/selectors';

const GroupParameters = () => {
  const dispatch = useDispatch();

  const parameters = useSelector(selectStencilsParameters);
  const stencils = useSelector(selectStencils);

  if (!stencils || !stencils.length) {
    return null;
  }

  const groupName = 'groupParameters';
  const onChangeParameter = (name, value) => dispatch(changeStencilsParameter({ name, value }));
  return (
    <div className="row">
      <div className="col-12 col-sm-6">
        <Panelize
          required
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Panelize', parameters.panelize, 'required')} />
      </div>
      <div className="col-12 col-sm-6">
        <PrintConfirmation
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Check Plot', parameters.print_confirmation, 'required')} />
      </div>
      <div className="col-12">
        <SpecialInstructions
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          rows="2" />
      </div>
    </div>
  );
};

export default GroupParameters;